export const sortCycleInfo = (cycleInfo) => {
  return cycleInfo.sort(function (a, b) {
    if (a.cyc_name < b.cyc_name) return -1;
    if (a.cyc_name > b.cyc_name) return 1;
    return 0;
  });
};
